import { Dispatch } from 'react';

import {
  getPermissionsErrorAction,
  getUserAction,
  getUserSuccessAction,
  getUserErrorAction,
  UserAction,
  getUserRoleAction,
} from './user-actions';
import {
  getCurrentUser,
  getUserPermissions,
  GetUserRole,
} from '../../api/user';
import { ProductPermissions, ProductType } from '../../constants/constants';
export interface UserThunks {
  getCurrentUser(): Promise<void>;
}

const fetchPermissions = async (
  dispatch: Dispatch<UserAction>
): Promise<ProductPermissions[]> => {
  try {
    return await getUserPermissions(ProductType);
  } catch (error) {
    dispatch(getPermissionsErrorAction(error));
    return [];
  }
};

const fetchRole = async (
  dispatch: Dispatch<UserAction>,
  employeeId: string
): Promise<any> => {
  try {
    const payload = {
      coworkerId: employeeId,
      menuRequired: false,
      storesRequired: false,
    };
    const response = await GetUserRole(payload);
    return response?.coworkerProfile?.role;
  } catch (error) {
    dispatch(getUserRoleAction(error));
    return [];
  }
};

export const getCurrentUserThunk =
  (dispatch: Dispatch<UserAction>) => async () => {
    try {
      dispatch(getUserAction());

      const currentUser = await getCurrentUser();
      const permissions = await fetchPermissions(dispatch);
      const role = await fetchRole(dispatch, currentUser.employeeId);

      const userData = {
        ...currentUser,
        permissions,
        role,
      };

      dispatch(getUserSuccessAction(userData));
    } catch (error) {
      dispatch(getUserErrorAction(error));
    }
  };
